<template>
    <div style="background: #fff" >
        <v-container
            v-if="loadingAlimentos"
            fluid
            text-xs-center
            fill-height
            align-center
            style="padding:0; margin: 0;"
        >
            <v-layout
                column
                fill-height
                justify-center
                align-center
                >
                <v-flex
                    xs12
                    sm12
                    md12
                    lg6
                    xl6>
                    <v-progress-circular
                    :size="150"
                    color="primary"
                    indeterminate>
                    <span>{{ strings[idioma].aguarde }}</span>
                    </v-progress-circular>
                </v-flex>
                <span style="font-weight: 500; padding: 4px">
                    {{ strings[idioma].carregando }}
                </span>
            </v-layout>
        </v-container>
        <v-card v-else="!loadingAlimentos" flex wrap style="background: #fff">
            <v-card-title>
                <h3>{{ strings[idioma].comparar_dietas }}</h3>
                <v-spacer/>
                <v-select
                    v-model="dietasSelecionadas"
                    :items="dietas"
                    :item-text="'nome'"
                    :item-value="'id'"
                    :label="strings[idioma].filtrar_dieta"
                    attach
                    chips
                    multiple
                />
            </v-card-title>
            
            <hr />
            <v-flex>
                
                <v-tabs v-model="tab">
                    
                    <v-tab>{{ strings[idioma].alimentos }}</v-tab>
                    <v-tab>{{ strings[idioma].financeiro_beefplan }}</v-tab>
                </v-tabs>
            </v-flex>
            
            <v-container v-if="tab === 0">
                <v-flex style="height: 100vh; overflow: auto; background: #fff;">
                    <table id="table_dietas" :class="'table ' + (transpor ? 'transpor' : '')" style="background: #fff; overflow: auto; width: 100%" border="1">
                        <tbody id="table_compara_dietas">
                            <tr v-if="!transpor">
                            <th style="width: 30%"></th>
                            <th style="width: 30%"></th>
                            <th v-for="al, index in alimentosTab" class="verticalTableHeader2" :key="index"><p>{{ al }}</p></th>
                            </tr>
                            <tr v-if="transpor">
                            <td><p>-</p></td>
                            <td><p>-</p></td>
                            <td v-for="al, index in alimentosTab" :key="index"><p>{{ al }}</p></td>
                            </tr>
                            <tr v-for="dieta, index in dietasTab" :key="index" @click="openDieta(dietasFiltradas[index])" style="cursor: pointer;">
                            <td v-for="r, i in dieta" style="min-width: 50px;" :key="index + '-' + i" :title="i >= 2 ? dietasTab[index][0] + ' - ' + alimentosTab[i - 2] : ''"><p>{{ r }}</p></td>
                            </tr>
                        </tbody>
                    </table>
                </v-flex>
            </v-container>
            <v-container v-if="tab === 1">
                <v-flex style="height: 100vh; overflow: scroll; background: #fff;">
                    <table id="table_dietas" :class="'table ' + (transpor ? 'transpor' : '')" style="background: #fff; overflow: scroll;" border="1">
                        <tbody id="table_compara_dietas">
                            <tr v-if="!transpor">
                            <!---<th style="width: 30%"></th>-->
                            <template>
                                <th v-for="fin, index in finHeader" class="verticalTableHeader2" :key="index"><p>{{ fin }}</p></th>
                            </template>
                            </tr>
                            <tr v-else>
                            <template>
                                <td v-for="fin, index in finHeader" :key="index"><p>{{ fin ? fin : '-' }}</p></td>
                            </template>
                            </tr>
                            <template>
                            <tr v-for="dieta, index in Object.values(finTab)" :key="index" @click="openDieta({ id: dieta.id })" style="cursor: pointer;">
                                <td v-for="r, i in dieta" style="min-width: 50px;" :key="index + '-' + i" :title="i >= 2 ? finTab[index][0] + ' - ' + finHeader[i - 2] : ''">
                                <p>
                                    {{ r['unidadeEsq'] !== undefined ? r['unidadeEsq'][idioma] : '' }} {{ r['valor'] !== undefined ? parseFloat(r['valor']).toFixed(2).replace('.', strings[idioma].separador_float) : r }} {{ r['unidadeDir'] !== undefined ? r['unidadeDir'][idioma] : '' }}
                                </p>
                                </td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                </v-flex>
            </v-container>
            <v-btn @click="exportar">{{ strings[idioma].exporta_csv }}</v-btn>
        </v-card>
        
    </div>
</template>
<style scoped>
.table {
  border-collapse: collapse;
  width: 100%;
}
.table td, .table th{
  /*padding: 10px;*/
}
.table thead{
  background: #b1adad;
}
.table tr:nth-child(2n) td{
  background: #e1e1e1;
}
.table .verticalTableHeader2 {
    padding: 5px;
}
</style>
<script>
import { mapState } from 'vuex'
import { getData, updateData, getAlimentos, transposeTable, createMD5, exportTableToExcel } from '@/utils/utils'

export default {
    data () {
        return {
            transpor: false,
            finHeader: [],
            finTab: [],
            dietasTab: [],
            alimentosTab: [],
            dietasSelecionadas: [],
            dietasFiltradas: [],
            tab: 0,
            loadingAlimentos: false

        }
    },
    computed: {
        ...mapState('app', ['idioma', 'strings', 'dietas', 'categorias_alimentos', 'ingredientes', 'user'])
    },
    watch: {
        idioma () {
            this.resetIdioma()
            this.montaMatrizDietas(this.dietas)
        },
        dietasSelecionadas () {
            this.montaMatrizDietas(this.dietas)
        }
    },

    mounted () {
        this.loadAlimentosDieta(() => {
            this.montaMatrizDietas(this.dietas)
        })
        
    },
    methods: {
        exportar () {
            exportTableToExcel('table_dietas')
        },
        async openDieta (dieta) {
            // this.$store.commit('loadDieta', dieta)
            setTimeout(async () => {
                let url = '/formulacao-dieta?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id))
                let win = window.open(url, '_blank')
                if (!win) window.location.href = url
            }, 300)
        },
        loadAlimentosDieta (callback=() => {}) {
            if (this.categorias_alimentos !== null) return callback(this.categorias_alimentos)
            this.loadingAlimentos = true
            
            getAlimentos(this.$store, this.axios).then((r) => {
                this.loadingAlimentos = false
                callback(r)
            })
        },
        resetIdioma () {
            this.finHeader = []
            this.finTab = []
            this.dietasTab = []
            this.alimentosTab = []
        },
        transporDietas (idHTML = '') {
            this.transpor = !this.transpor
            // transposeTable(document.getElementById(idHTML))
        },
        montaMatrizDietas (val) {
            console.log({ val })
            if (val === null || this.categorias_alimentos === null) return
            
            const alimentosSt = JSON.parse(localStorage.getItem('alimentosStored'))
            let alimentosTab = []
            let dietasTab = []
            let financeiro = []
            let finHeader = []
            if (this.dietasSelecionadas.length > 0) val = val.filter(d => this.dietasSelecionadas.includes(d.id))
            this.dietasFiltradas = val
            for (let d of val) {
                let finDieta = this.gerarRelatorioFinanceiro(d.animal, d.custo)
                let finDietaTotal = {id: d.id, nome: d.nome,...finDieta['ATC'], ...finDieta['IAE']}
                
                for (let itemFin in finDietaTotal) {
                if (['id', 'nome'].includes(itemFin)) continue
                if (isNaN(finDietaTotal[itemFin].valor)) {
                    finDietaTotal[itemFin].valor = 0
                }
                }
                if (parseInt(finDietaTotal['N'].valor) > 0) {
                financeiro.push(finDietaTotal)
                }
                dietasTab.push(d)
                alimentosTab = [...alimentosTab, ...Object.keys(d.resultado ? d.resultado : [])]
            }
            if (financeiro !== null && financeiro.length !== 0 && this.finHeader.length === 0) {
                finHeader = Object.values(financeiro[0] ? financeiro[0] : []).map(f => f.title ? f.title[this.idioma] : null)
            } else {
                finHeader = this.finHeader
            }
            alimentosTab = new Set(alimentosTab)
            alimentosTab = [...alimentosTab]
            dietasTab = Object.values(dietasTab).map(d => {
                return [
                d.id,
                d.nome,
                ...(Object.values(alimentosTab).map(a => {
                    return d.resultado ? (Object.keys(d.resultado).includes(a) ? parseFloat(d.resultado[a]).toFixed(4) : '-') : '-'
                }))
                ]
            })
            let c = this.categorias_alimentos.filter(c => c.id > 900).map(cc => {
                return [...cc.derivados]
            })
            alimentosTab = alimentosTab.map(a => {
                let nome = alimentosSt[a] ? alimentosSt[a][this.idioma === 0 ? 'name' : this.idioma === 1 ? 'name_en' : 'name_es'] : a
                c.forEach(el => {
                let index = el.findIndex((e) => e.id === a)
                if (index !== -1) {
                    nome = el[index][this.idioma === 0 ? 'name' : this.idioma === 1 ? 'name_en' : 'name_es']
                }
                });
                return nome 
            })
            this.dietasTab = dietasTab
            this.alimentosTab = alimentosTab
            this.finHeader = finHeader
            this.finTab = financeiro
        }
    }
}
</script>